<layer-header *ngIf="store.state.common.determinantSection.topLayer === 'list'"
              (closeLayer)="closeLayer()"
              (setListView)="setListView($event)"
              [listToggle]="listToggle"
              [listIcons]=false
              [title]="'Edit Determinant'">
    <ng-content></ng-content>
</layer-header>
<determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
                  class="row layer px-3 pt-1"
                  [serviceId]="serviceId"
                  [determinant]="store.state.common.determinantSection.determinant"
                  (formSubmit)="closeEdit()"
                  (editCancel)="closeEdit()"></determinant-new>
<div class="row {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden': ''}}">
  <div class="col-12">
    <determinant-builder-new [serviceId]="serviceId"
                             [jsonString]="jsonString"
                             (onChange)="jsonString = $event"
                             [lateralSpacing]=true
                             (onSave)="onSave($event)"
                             (onCancel)="closeLayer()">
    </determinant-builder-new>
  </div>
</div>
